/**
 * Site-wide wrapper. No markup, no runtime.
 *
 * Until Phase 6 this loaded jQuery and Webflow's interactions engine for every
 * visitor. Both are gone: the nav is `useChromeNav`, the tabs are
 * `useWebflowTabs`, and the `opacity: 0` initial states the engine existed to
 * reveal are no longer in the markup.
 *
 * Kept as the seam the chrome hangs off, so RootLayout reads the same and
 * there is one obvious place for anything genuinely site-wide.
 */
export function Chrome({ children }: { children: React.ReactNode }) {
  return <>{children}</>
}
